"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = combined;
var _getClosestTranslationTarget = require("../utils/getClosestTranslationTarget");
var _getLevelData = require("./utils/getLevelData");
/**
 * Only to be used for transport and energy categories
 * @param  {string} value
 * @param  {string} category [ 'transport' ]
 * @param  {string} dataSource 'norway'
 * @returns {object} levelData
 */
function combined(_ref) {
  var value = _ref.value,
    category = _ref.category,
    dataSource = _ref.dataSource;
  var closestTarget = (0, _getClosestTranslationTarget.getClosestTranslationTarget)(value, category, dataSource);
  return (0, _getLevelData.getLevelData)(closestTarget, category, dataSource);
}
//# sourceMappingURL=index.js.map